export const JOB_POSITION = '/job-positions'
